
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaSkipNext as ObiMediaSkipNextElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-skip-next.js';
 
 
 

 
 export const ObiMediaSkipNext = createComponent({
   react: React,
   tagName: 'obi-media-skip-next',
   elementClass: ObiMediaSkipNextElement,
   events: {
     
   }
  });
 
 